import React from "react";

export default function SectionHeading({
  eyebrow,
  eyebrowIcon: EyebrowIcon,
  title,
  description,
  children,
  align = "center",
  theme = "dark",
  eyebrowClassName = "",
  titleClassName = "",
  descriptionClassName = "",
  lineClassName = "",
  containerClassName = "",
  eyebrowTag: EyebrowTag = "span",
  titleTag: TitleTag = "h2",
  showLine = true,
}) {
  const isLeft = align === "left";
  const alignmentClass = isLeft ? "items-start text-left" : "items-center text-center";
  const themeStyles = {
    dark: {
      eyebrow: "text-[#355dff]",
      title: "text-white",
      description: "text-gray-400",
      line: "bg-blue-600",
    },
    light: {
      eyebrow: "text-[#355dff]",
      title: "text-slate-900",
      description: "text-gray-600",
      line: "bg-blue-600",
    },
  };
  const activeTheme = themeStyles[theme] || themeStyles.dark;

  return (
    <div className={`w-full flex flex-col ${alignmentClass} ${containerClassName}`}>
      {eyebrow && (
        <EyebrowTag
          className={`inline-flex items-center gap-2 text-sm md:text-base font-semibold tracking-[0.32em] uppercase font-mono ${activeTheme.eyebrow} ${isLeft ? "justify-start" : "justify-center"} ${eyebrowClassName}`}
        >
          {EyebrowIcon && <EyebrowIcon className="w-4 h-4" />}
          {eyebrow}
        </EyebrowTag>
      )}

      {title && (
        <TitleTag
          className={`mt-4 text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight leading-tight ${activeTheme.title} ${isLeft ? "text-left" : "text-center"} ${titleClassName}`}
        >
          {title}
        </TitleTag>
      )}

      {showLine && (
        <div
          className={`w-24 h-1 rounded-full mt-5 ${activeTheme.line} ${isLeft ? "ml-0" : "mx-auto"} ${lineClassName}`}
        />
      )}

      {description && (
        <p
          className={`mt-6 text-lg sm:text-xl leading-relaxed max-w-2xl ${activeTheme.description} ${isLeft ? "text-left" : "text-center"} ${descriptionClassName}`}
        >
          {description}
        </p>
      )}

      {children}
    </div>
  );
}
